export const isLongTitle = title => {
    if (title) {
        return title.length >= 80;
    }
};

export const isLongText = (text, length) => {
    if (text) {
        const isLong = text.length > length ? true : false;
        return isLong;
    }
};
